import { useQuery } from '@apollo/client';
import { GetUserPreferencesDocument } from '@/__generated__/graphql';
import { fromLanguageEnum } from '../language';
import type { AppLocale } from '../locale-storage';
import type { UserRegionPreference } from '../model/resolve-region';

/**
 * Las preferencias del usuario: el idioma y la región (formatos, zona, `hour12`). Es la única lectura
 * de `GetUserPreferences` en `fsd/` (el idioma y la región salen de la misma `data`). Reutiliza el
 * documento del código existente (mismo documento generado, misma selección), así la caché de Apollo
 * es una sola para las dos ramas: lo que guarda el selector de `fsd/` lo lee el legado y al revés.
 */
export function useUserLocalePreference(): {
  userId: number | null;
  serverLocale: AppLocale | null;
  /** `null` mientras la query no llegó. */
  region: UserRegionPreference | null;
} {
  const { data } = useQuery(GetUserPreferencesDocument);
  const region = data?.user.preferences.region ?? null;
  return {
    userId: data?.user.id ?? null,
    serverLocale: fromLanguageEnum(region?.locale),
    region,
  };
}
